<template>
  <div id="series-graph-config">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card
        ><v-toolbar dark color="blue">
          <v-btn icon dark @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="$emit('save-config')">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list three-line subheader>
          <v-subheader>グラフ設定</v-subheader>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>期間</v-list-item-title>
              <v-list-item-subtitle>
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  max-width="460"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateRangeText"
                      clearable
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateRange"
                    @change="menu1 = false"
                    range
                    landscape
                  ></v-date-picker>
                </v-menu>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                表示項目
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="3" class="py-0 pr-0">
                      <v-checkbox
                        :label="getConfigValue('a', 'name')"
                        v-model="getConfigBy('a').visible"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="3" class="py-0 pr-0">
                      <v-checkbox
                        :label="getConfigValue('b', 'name')"
                        v-model="getConfigBy('b').visible"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="3" class="py-0 pr-0">
                      <v-checkbox
                        :label="getConfigValue('c', 'name')"
                        v-model="getConfigBy('c').visible"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="3" class="py-0 pr-0">
                      <v-checkbox
                        :label="getConfigValue('d', 'name')"
                        v-model="getConfigBy('d').visible"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="3" class="py-0 pr-0">
                      <v-checkbox
                        :label="getConfigValue('temp', 'name')"
                        v-model="getConfigBy('temp').visible"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>ゲージ係数</v-list-item-title>
              <v-list-item-subtitle>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="getConfigBy('a').coeff"
                      label="CH-A"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="getConfigBy('b').coeff"
                      label="CH-B"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="getConfigBy('c').coeff"
                      label="CH-C"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="getConfigBy('d').coeff"
                      label="CH-D"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>ゼロリセット</v-list-item-title>
              <v-list-item-subtitle>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="getConfigBy('a').offset"
                      label="CH-A"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="getConfigBy('b').offset"
                      label="CH-B"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="getConfigBy('c').offset"
                      label="CH-C"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="getConfigBy('d').offset"
                      label="CH-D"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>
          <v-subheader>詳細設定</v-subheader>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>ラベルの編集</v-list-item-title>
              <v-list-item-subtitle>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="getConfigBy('a').name"
                      label="CH-A"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="getConfigBy('b').name"
                      label="CH-B"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="getConfigBy('c').name"
                      label="CH-C"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="getConfigBy('d').name"
                      label="CH-D"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>
          <v-subheader>通知設定</v-subheader>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>しきい値の編集</v-list-item-title>

              <v-list-item-subtitle>
                <AxialLoadThresholdForm
                  :threshold="measure.threshold"
                  @update="updateThreshold"
                  v-if="measure.template_type === 'axial_load'"
                />
                <Strain4chThresholdForm
                  :threshold="measure.threshold"
                  @update="updateThreshold"
                  v-else
                />
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>メール通知</v-list-item-title>
              <v-list-item-subtitle>
                <v-checkbox
                  label="メールによる通知を有効にする"
                  v-model="measure.notification.enabled"
                  :disabled="addresses.length == 0"
                ></v-checkbox>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>通知先の編集</v-list-item-title>
              <v-list-item-subtitle>
                <address-register-form
                  @submit="addAddress"
                ></address-register-form>
                <address-list-table
                  :addresses="addresses"
                  @delete="removeAddress"
                ></address-list-table>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>
          <v-subheader>レイアウト</v-subheader>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title></v-list-item-title>
              <v-list-item-subtitle>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Y軸の表示単位"
                      :value="measure.yaxis_unit"
                      @input="updateUnit"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <template v-if="admin">
            <v-divider></v-divider>
            <v-subheader>その他</v-subheader>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>計測の削除</v-list-item-title>
                <v-list-item-subtitle>
                  <v-btn @click="confirmMeasureDelete = true">削除</v-btn>
                </v-list-item-subtitle>
                <v-dialog v-model="confirmMeasureDelete" max-width="400">
                  <DeleteConfirmation
                    @close="confirmMeasureDelete = false"
                    @confirm="deleteMeasure(measure.id)"
                    >計測 {{ measure.name }} を削除します。</DeleteConfirmation
                  >
                </v-dialog>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "@/api";
import Measure from "@/models/measure";

import Strain4chThresholdForm from "@/components/Strain4chThresholdForm";
import AxialLoadThresholdForm from "@/components/AxialLoadThresholdForm";
import AddressRegisterForm from "@/components/AddressRegisterForm.vue";
import AddressListTable from "@/components/AddressListTable.vue";
import DeleteConfirmation from "@/components/DeleteConfirmation.vue";

export default {
  name: "SeriesGraphConfig",
  components: {
    AddressRegisterForm,
    AddressListTable,
    DeleteConfirmation,
    Strain4chThresholdForm,
    AxialLoadThresholdForm,
  },
  props: {
    measure: { Type: Object, default: () => null },
    dialog: { Type: Boolean, default: () => false },
    notification: { type: Object, defautl: () => {} },
    admin: { type: Boolean, default: () => false },
  },
  data() {
    return {
      menu1: false,
      confirmMeasureDelete: false,
      measureParams: null,
    };
  },
  computed: {
    dateRange() {
      return [this.measure.start_date, this.measure.end_date];
    },
    dateRangeText() {
      return `${this.measure.start_date} ~ ${this.measure.end_date}`;
    },
    addresses() {
      if (!this.measure) {
        return [];
      }

      if (this.measure.notification.to_addresses.length === 0) {
        return [];
      }

      return this.measure.notification.to_addresses
        .split(",")
        .map((addr) => ({ email: addr }));
    },
  },
  methods: {
    getConfigBy(key) {
      return this.measure.graph_configs.find((c) => c.key === key);
    },
    getConfigValue(key, param) {
      let index = this.measure.graph_configs.findIndex((c) => c.key === key);

      if (index > -1) {
        return this.measure.graph_configs[index][param];
      } else {
        return null;
      }
    },
    deleteMeasure(measureId) {
      api.measures.delete(measureId).then(() => {
        Measure.delete(measureId);
        this.$router.push(`/${this.$route.params.customer}/home`);
      });
    },
    updateThreshold(params) {
      this.measure.threshold = Object.assign(this.measure.threshold, params);
    },
    addAddress(event) {
      api.addNotificationAddress(this.measure.id, event).then((data) => {
        this.measure.notification = data;
      });
    },
    removeAddress(event) {
      api.deleteNotificationAddress(this.measure.id, event).then(() => {
        let addrArray = this.measure.notification.to_addresses.split(",");
        const index = addrArray.findIndex((addr) => addr === event.email);
        addrArray.splice(index, 1);

        this.measure.notification.to_addresses = addrArray.join(",");
      });
    },
    updateUnit(event) {
      this.measure.yaxis_unit = event;
    },
  },
};
</script>

<style></style>
